import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { OfferType, ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { BreakpointWidth } from '@domgen/dgx-fe-common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, fromEvent } from 'rxjs';
@UntilDestroy()
@Component({
  selector: 'app-offer-container',
  templateUrl: './offer-container.component.html',
  styleUrls: ['./offer-container.component.scss'],
})
export class OfferContainerComponent implements OnInit, OnChanges {
  /**
   * Emits a click event from the show more CTA to parent
   */
  @Output() showMoreClicked: EventEmitter<OfferType> = new EventEmitter();

  /**
   * Emit clicked Offer
   */
  @Output()
  comparisonClicked: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Emit click event from sibling
   */
  @Output() cardClicked: EventEmitter<ReplacementOffer> = new EventEmitter();

  /**
   * Receives an array of offers to be displayed
   */
  @Input() replacementOffers = [] as ReplacementOffer[];

  /**
   * RRPFlag value for the current product
   */
  @Input() rrpFlag: boolean;

  /**
   * Tracks state of visible offers
   */
  visible = 0;

  /**
   * comparisons selected
   */
  @Input() comparisonsSelected = [] as ReplacementOffer[];

  /**
   * Number of offers from the array to be shown onInit AND when the showMore CTA is click
   */
  @Input() showMoreSize: number;

  /**
   * Sets the state of the CTA. TRUE: populates more offers. FALSE: route change
   */
  @Input() dynamicCTA = true;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.setVisibleProducts();
    fromEvent(window, 'resize')
      .pipe(untilDestroyed(this), debounceTime(200))
      .subscribe(() => this.setVisibleProducts());
  }

  setVisibleProducts() {
    if (this.visible > this.showMoreSize) return;
    const isDesktop = window.innerWidth >= BreakpointWidth.xl;
    this.showMoreSize = isDesktop ? 3 : 4;
    this.visible = isDesktop ? 3 : 4;
    this.cdr.detectChanges();
    this.calcVisibleOffers(this.visible);
  }
  /**
   * OnChanges calculate visible offers
   */
  ngOnChanges() {
    if (this.replacementOffers) {
      const totalToShow = this.visible || this.showMoreSize;
      this.calcVisibleOffers(totalToShow);
    }
  }

  /**
   * Calculate visible offers size
   */
  calcVisibleOffers(totalToShow: number) {
    this.visible =
      this.replacementOffers.length >= totalToShow
        ? totalToShow
        : this.replacementOffers.length;
  }

  /**
   * Calculate the new visible offers state
   */
  calcShowMore() {
    const totalToShow = this.showMoreSize + this.visible;
    this.calcVisibleOffers(totalToShow);
  }

  /**
   * Show more or navigate when show more cta is clicked
   */
  onShowMoreClick() {
    const offerType =
      this.replacementOffers && this.replacementOffers[0]?.offer_type;
    this.showMoreClicked.emit(offerType);
    this.dynamicCTA ? this.calcShowMore() : this.router.navigate(['/offers']);
  }

  /**
   * emit when card clicked for comparison
   */
  onComparisonClick(replacementOffer: ReplacementOffer) {
    this.comparisonClicked.emit(replacementOffer);
  }

  /**
   * emit when Card clicked
   */
  onCardClick(replacementOffer: ReplacementOffer) {
    this.cardClicked.emit(replacementOffer);
  }
}
